module.exports = __webpack_public_path__ + "img/00002.5abffb57.webp";